import axios from 'axios';
import { createSlice } from '@reduxjs/toolkit';


const initialState = {
   
};

export const NotificationSlice = createSlice({

  name: 'notifications',
  initialState,
  reducers: {

  load : (state, action) => {
    console.log('NotificationSlice:load')
    console.log(action.payload)
    const data = action.payload
    return {
        ...state,
        ...data
    }
  }
 }
});


export const { 
  load
} = NotificationSlice.actions;

export default NotificationSlice.reducer;
